import type { ApiResponse } from '@news-cms/shared';

const baseUrl = import.meta.env.VITE_API_URL ?? 'http://localhost:8787';

export class ApiError extends Error {
  constructor(
    public readonly code: string,
    message: string,
    public readonly status: number,
    /** Optional backend-emitted detail payload — e.g. `{ issues: ZodIssue[] }`
     *  on VALIDATION_ERROR responses. Surface in form-level error displays. */
    public readonly details?: unknown,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(`${baseUrl}${path}`, {
    ...init,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...init.headers,
    },
  });

  const json = (await res.json().catch(() => null)) as ApiResponse<T> | null;

  if (!res.ok || !json || 'error' in json) {
    const code = json && 'error' in json ? json.error.code : 'NETWORK_ERROR';
    const message = json && 'error' in json ? json.error.message : `Request failed (${res.status})`;
    const details =
      json && 'error' in json && 'details' in json.error
        ? (json.error as { details?: unknown }).details
        : undefined;
    throw new ApiError(code, message, res.status, details);
  }

  return json.data;
}
